import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

/**
 * Layout for the MobX-free Configure Email dialog: the top "allow multiple domains / add
 * configuration" row, the scrollable list of provider-configuration rows, and the three-up
 * "send email features" area (Business Hours / Holidays / Email Domain). All tokens from `THEME`.
 */
export const emailConfigurationsDialogStyles = StyleSheet.create({
	popup: {
		maxWidth: 760,
		width: '100%',
		left: '50%',
		top: '50%',
		translate: '-50% -50%',
		// The per-holiday list makes the dialog taller than a short viewport; scroll the body and keep
		// the title and the Cancel/Save footer in place.
		maxHeight: 'calc(100vh - 64px)',
	},
	body: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.lg,
		marginTop: THEME.spacing.sm,
		minHeight: 0,
		overflowY: 'auto',
	},
	topRow: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		gap: THEME.spacing.md,
	},
	checkboxRow: {
		alignItems: 'center',
		cursor: 'pointer',
		display: 'flex',
		fontSize: THEME.typography.fontSizes.sm,
		gap: THEME.spacing.sm,
	},
	configList: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
		maxHeight: 480,
		overflowY: 'auto',
	},
	featuresGrid: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: THEME.spacing.xl,
		borderTop: THEME.common.border,
		paddingTop: THEME.spacing.lg,
	},
	featureColumn: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		minWidth: 200,
	},
	featureHeader: {
		alignItems: 'center',
		color: THEME.colors.text.dark,
		display: 'flex',
		fontWeight: THEME.typography.fontWeights.bold,
		gap: THEME.spacing.xs,
	},
	infoTrigger: {
		alignItems: 'center',
		cursor: 'help',
		display: 'inline-flex',
	},
	link: {
		color: THEME.colors.primary.main,
		cursor: 'pointer',
		fontSize: THEME.typography.fontSizes.sm,
		height: 'auto',
		padding: 0,
		textDecoration: 'none',
		width: 'fit-content',
		':hover': {
			color: THEME.colors.hover.main,
		},
	},
	holidayList: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		marginTop: THEME.spacing.xs,
	},
	holidayRow: {
		alignItems: 'center',
		display: 'flex',
		fontSize: THEME.typography.fontSizes.sm,
		gap: THEME.spacing.sm,
	},
	holidayRowIndented: {
		marginLeft: THEME.spacing.lg,
	},
	holidayLabel: {
		cursor: 'pointer',
	},
	domainText: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
	},
	spinnerOverlay: {
		alignItems: 'center',
		backgroundColor: 'rgba(255, 255, 255, 0.6)',
		display: 'flex',
		inset: 0,
		justifyContent: 'center',
		position: 'absolute',
		zIndex: 1,
	},
});
